import { useSelector } from 'react-redux';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { DetailsBackground } from '../details-background/details-background';
import { useDetails } from '../details-context';
import { DetailsController } from '../details-controller/details-controller';
import { DetailsMetadata } from '../details-metadata/details-metadata';
import { PurchaseProductModal } from '../purchase-product-modal/purchase-product-modal';
import { useDetailsImage } from '../use-details-image';
import { DetailsHeader } from './details-header';
import { DetailsTopButtons } from '../details-top-buttons/details-top-buttons';
import css from './details-view.module.scss';
import React, { useEffect } from 'react';
import { tracker } from '../../../tracker';
import { DetailsPanelOpenedEvent } from '../../../tracker/events/details-panel-opened';
import { useDetailsSearchParams } from '../use-details-search-params';
import { Helmet } from 'react-helmet-async';

interface DetailsViewProps {
  asset: Asset;
}

export function DetailsView({ asset }: DetailsViewProps) {
  const { focusedAsset, source, isTransactionModalOpen, setIsTransactionModalOpen } = useDetails('DetailsView');

  const isAuth = useSelector((state) => state.authReducer.loggedInWithCredentials);
  const src = useDetailsImage({ asset, shape: 'wide', width: 1400 });

  const { page, section } = useDetailsSearchParams();

  useEffect(() => {
    tracker.track(new DetailsPanelOpenedEvent(asset, source, page, section));
    // We only want to track on mount. This is fine
    // since we have all values available on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={css.container}>
      <Helmet>
        {asset.type === 'episode' ? (
          <title>
            {asset.series.titleName} - {asset.titleName} - Altibox TV
          </title>
        ) : (
          <title>{asset.titleName} - Altibox TV</title>
        )}
      </Helmet>

      {isAuth && source.type === 'vod' ? (
        <PurchaseProductModal
          asset={focusedAsset}
          source={source}
          isOpen={isTransactionModalOpen}
          onClose={() => setIsTransactionModalOpen(false)}
        />
      ) : null}

      <DetailsBackground src={src} />

      <DetailsTopButtons />

      <DetailsHeader asset={asset} source={source} focusedAsset={focusedAsset} />

      <DetailsController asset={asset} />
      <DetailsMetadata asset={asset} source={source} />
    </div>
  );
}
